import * as React from "react";
const CreateFluidReportView = React.lazy(() => import("./CreateFluidReportViewContainer"));

export { CreateFluidReportView };
